/* Brents buttons: hold the pressed state long enough to be seen.
   A quick click releases before a 400ms sweep could play, so pointerdown adds .is-pressed and the
   class stays on for at least HOLD ms. Which elements take part comes from --brents-press in
   assets/brents-buttons.css: "sweep" (primary / secondary fill) or "tap" (text / icon flash). */
(function () {
  var HOLD = { sweep: 550, tap: 150 };

  function pressType(el) {
    return getComputedStyle(el).getPropertyValue('--brents-press').trim();
  }

  function pressable(node) {
    var el = node && node.closest ? node.closest('a, button, summary, [role="button"]') : null;
    if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') return null;
    return HOLD[pressType(el)] ? el : null;
  }

  function press(el) {
    clearTimeout(el._brentsRelease);
    el.classList.remove('is-pressed');
    void el.offsetWidth; // restart the sweep on a repeated press
    el.classList.add('is-pressed');
    el._brentsPressedAt = Date.now();
  }

  function release(el) {
    var wait = HOLD[pressType(el)] - (Date.now() - el._brentsPressedAt);
    el._brentsRelease = setTimeout(function () {
      el.classList.remove('is-pressed');
    }, Math.max(0, wait));
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.button !== 0) return;
    var el = pressable(event.target);
    if (!el) return;
    press(el);
    function up() {
      release(el);
      document.removeEventListener('pointerup', up);
      document.removeEventListener('pointercancel', up);
    }
    document.addEventListener('pointerup', up);
    document.addEventListener('pointercancel', up);
  });

  document.addEventListener('keydown', function (event) {
    if (event.repeat || (event.key !== 'Enter' && event.key !== ' ')) return;
    var el = pressable(event.target);
    if (!el) return;
    press(el);
    release(el);
  });

  // Back/forward cache can restore a page mid-press
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('.is-pressed').forEach(function (el) {
      el.classList.remove('is-pressed');
    });
  });
})();
